export class Prefetch {
  private targets?: NodeListOf<HTMLAnchorElement>;
  constructor() {
    this.init();
  }

  private init() {
    this.cleanup();
    this.targets = document.querySelectorAll<HTMLAnchorElement>('a');
    this.targets.forEach((anchor) => {
      anchor.addEventListener('mouseover', this.handleMouseOver);
    });
  }

  private cleanup() {
    this.targets?.forEach((anchor) => {
      anchor.removeEventListener('mouseover', this.handleMouseOver);
    });
  }

  private handleMouseOver = (event: MouseEvent) => {
    const anchor = event.currentTarget as HTMLAnchorElement;
    anchor.removeEventListener('mouseover', this.handleMouseOver);
    const href = anchor.href;
    if (href) {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    }
  };
}
